import { WETH9 as WETH, Token } from '@uniswap/sdk-core'

import invariant from 'tiny-invariant'
import { Currency } from '@uniswap/sdk-core'
import { NativeCurrency } from '@uniswap/sdk-core'

type WETH9Type = {
  [chainId: number]: Token
}

export const WETH9: WETH9Type = {
  ...WETH,
  248832: new Token(248832, '0x9dbA31E492b7E98B8195e254EE13b6B027e4a59D', 18, 'WETH', 'Wrapped Ether'),
}

/**
 * Ether is the main usage of a 'native' currency, i.e. for Ethereum mainnet and all testnets
 */
export class Ether extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'ETH', 'Ether')
  }

  public get wrapped(): Token {
    const weth9 = WETH9[this.chainId]
    invariant(!!weth9, 'WRAPPED')
    return weth9
  }

  private static _etherCache: { [chainId: number]: Ether } = {}

  public static onChain(chainId: number): Ether {
    return this._etherCache[chainId] ?? (this._etherCache[chainId] = new Ether(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
